module.exports = __webpack_public_path__ + "static/media/chevron-square-down.ea3008e1.svg";